import { render, staticRenderFns } from "./DemandDateGrid.vue?vue&type=template&id=1a980b93&scoped=true&"
import script from "./DemandDateGrid.vue?vue&type=script&lang=js&"
export * from "./DemandDateGrid.vue?vue&type=script&lang=js&"
import style0 from "./DemandDateGrid.vue?vue&type=style&index=0&id=1a980b93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a980b93",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VItem,VItemGroup,VRow,VSpacer})
